<template>

    <!-- switched to button in VOT-288 to fix VOT-300 -->
    <!--    <a href="#"-->
    <button type="button"
            class="list-group-item list-group-item-action"
            v-bind:aria-current="ariaStatus"
            v-bind:class="styling"
            v-on:click="handleSelect"
            data-test="office-select-row"
    ><i v-if="hasVoted" class="bi-check text-success"></i>
        <span v-bind:class="textStyling">{{ officeName }}</span>
    </button>

</template>

<script>
import MeetingMixin from "../../../../mixins/meetingMixin";
import motionObjectMixin from "../../../../mixins/motionObjectMixin";
import {isReadyToRock} from "../../../../utilities/readiness.utilities";

export default {
    name: "office-select-row",

    /**
     * motion (the currently selected motion) will be available
     * via mixin. Hence this naming
     */
    props: ['motion'],


    mixins: [MeetingMixin, motionObjectMixin],

    data: function () {
        return {}
    },


    computed: {
        // asyncComputed: {
        officeName: function () {
            return this.motion.content;
        },

        /**
         * Returns true if the user has already voted on this office
         */
        hasVoted: function () {
            if (!isReadyToRock(this.motion)) return false;
            return this.$store.getters.hasVotedOnMotion(this.motion);
        },

        /**
         * Returns true if there's a problem which
         * should prevent navigation or submission, e.g.,
         * overselection
         */
        isError: function () {
            if (!isReadyToRock(this.motion)) return '';

            return this.$store.getters.showOverSelectionWarningForMotion(this.motion);

            // return true;
        },

        /**
         * Whether the motion that has been handed to this
         * component is the one globally selected.
         *
         * Will not show as selected if the summary card is showing (even if
         * the given motion is the one currently on top of the stack)
         *
         * @returns {boolean}
         */
        isSelected: function () {
            if (_.isUndefined(this.selectedMotion) || _.isNull(this.selectedMotion)) return false

            //Do not show as selected if summary or other informational cards are showing
            if (this.$store.getters.isSummarySubmitCardVisible) return false;
            if (this.$store.getters.isInstructionsCardVisible) return false;
            if (this.$store.getters.isCompleteCardShown) return false;

            return this.motion.id === this.selectedMotion.id
        },

        /**
         * The current globally active motion
         * @returns {any}
         */
        selectedMotion: function () {
            return this.$store.getters.getActiveMotion;
        },

        ariaStatus: function () {
            if (this.isSelected) {
                return 'true'
                // return ' bg-info '
            }
            return 'false'
        },

        styling: {
            get: function () {
                if (this.isSelected) {
                    return ' active '
                }

                //dev VOT-300 Switching to button made the text-muted class
                // not affect the rendered display. Adding the disabled class does
                // work, but concerned that users may not understand why they can't
                // click so leaving commented out for now
                //if(this.hasVoted) { return 'disabled'}

            },
            default: ''
        },

        textStyling: function () {
            if (this.hasVoted) return 'text-muted';

            if (this.isError) return 'text-danger'
        }

    },


    methods: {
        handleSelect: function () {
            // window.console.log('setting office ');
            this.$store.dispatch('setOfficeForVoting', this.motion);
        }
    }

}
</script>

<style scoped>

</style>
